import { render, staticRenderFns } from "./NewNetlinkPopupTable.vue?vue&type=template&id=8f1e420a&scoped=true"
import script from "./NewNetlinkPopupTable.vue?vue&type=script&lang=js"
export * from "./NewNetlinkPopupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e420a",
  null
  
)

export default component.exports